import axios from "axios";

export function callSendGuestInvitation(guestEmail: string) {
  return axios({
    method: "POST",
    url: "/api/Guest/send-visitor-invitation",
    headers: {
      "Content-Type": "application/json"
    },
    data: JSON.stringify(guestEmail)
  });
}

export function callResendGuestInvitation (guestId: any){
  return axios({
    method: "POST",
    url: "/api/Guest/resend-visitor-invitation",
    headers: {
      "Content-Type": "application/json"
    },
    data: JSON.stringify(guestId)
  });
}

export function callGetMemberGuests(){
    return axios({
        method: "GET",
        url: "/api/Guest/get-member-guests"
    });
}
